// extracted by mini-css-extract-plugin
export var wordContainer = "_sg-0";